/* Crawler Madness theme — small, dependency-free progressive enhancements. */
(function () {
  'use strict';

  // Reveal-on-scroll for .rev elements.
  var revs = document.querySelectorAll('.rev');
  if ('IntersectionObserver' in window && revs.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    revs.forEach(function (el) { io.observe(el); });
  } else {
    revs.forEach(function (el) { el.classList.add('in'); });
  }

  // Nudge muted autoplay on any standalone featured videos (some browsers need it).
  document.querySelectorAll('.feature video').forEach(function (v) {
    var p = v.play();
    if (p && p.catch) { p.catch(function () {}); }
  });

  // Hero slideshow — one clip at a time with a crossfade. Only the ACTIVE video ever
  // plays (the rest are paused, so one video decodes at a time — gentle on phones).
  // A video advances when it finishes; an image holds for data-image-seconds.
  document.querySelectorAll('[data-hero-slideshow]').forEach(function (show) {
    var slides = Array.prototype.slice.call(show.querySelectorAll('.slide'));
    if (slides.length === 0) return;

    var imageMs = (parseInt(show.getAttribute('data-image-seconds'), 10) || 5) * 1000;

    // A single clip doesn't slideshow — just play it (looping, if it's a video).
    if (slides.length === 1) {
      slides[0].classList.add('is-active');
      var solo = slides[0].querySelector('video');
      if (solo) { solo.loop = true; var sp = solo.play(); if (sp && sp.catch) sp.catch(function () {}); }
      return;
    }

    var idx = 0;
    for (var i = 0; i < slides.length; i++) { if (slides[i].classList.contains('is-active')) { idx = i; break; } }
    slides[idx].classList.add('is-active');

    var timer = null;
    function clearTimer() { if (timer) { clearTimeout(timer); timer = null; } }

    function leave(slide) {
      var v = slide.querySelector('video');
      if (v) { v.onended = null; v.onerror = null; v.onloadedmetadata = null; try { v.pause(); v.currentTime = 0; } catch (e) {} }
    }

    function enter(slide) {
      warm(slide); // a slide never shows without its media, even if it wasn't warmed ahead
      var v = slide.querySelector('video');
      if (!v) { timer = setTimeout(next, imageMs); return; } // image: hold, then advance
      v.onended = next;
      v.onerror = next;
      // Safety net so a stalled/blocked video can't freeze the show: advance a hair
      // after its known length (cap unknown-length at 60s), independent of `ended`.
      var arm = function () {
        clearTimer();
        var secs = (v.duration && isFinite(v.duration) && v.duration > 0) ? v.duration + 0.6 : 60;
        timer = setTimeout(next, secs * 1000);
      };
      if (v.readyState >= 1) arm(); else v.onloadedmetadata = arm;
      var p = v.play();
      if (p && p.catch) p.catch(function () { clearTimer(); timer = setTimeout(next, imageMs); });
    }

    // Warm the upcoming slide while the current one shows, so it appears with no flash.
    // Since theme 1.34.0 slides after the first ship WITHOUT their media URLs: every
    // slide sits in the same on-screen box, so loading="lazy" never held them back and
    // a phone fetched every photo and cover up front. They carry data-src (photo),
    // data-bg (the slide's cover background), data-poster and preload="none" (video),
    // handed over here. The loading="lazy" nudge is kept for the theme-hosted Clip
    // blocks, which still ship plain lazy images.
    function warm(slide) {
      var img = slide.querySelector('img[data-src]');
      if (img) { img.setAttribute('src', img.getAttribute('data-src')); img.removeAttribute('data-src'); }
      var lazy = slide.querySelector('img[loading="lazy"]');
      if (lazy) lazy.loading = 'eager';
      var bg = slide.getAttribute('data-bg');
      if (bg) { slide.style.backgroundImage = "url('" + bg + "')"; slide.removeAttribute('data-bg'); }
      var v = slide.querySelector('video');
      if (v) {
        var poster = v.getAttribute('data-poster');
        if (poster) { v.setAttribute('poster', poster); v.removeAttribute('data-poster'); }
        if (v.getAttribute('preload') === 'none') v.setAttribute('preload', 'metadata');
      }
    }

    function next() {
      clearTimer();
      warm(slides[(idx + 2) % slides.length]);
      leave(slides[idx]);
      slides[idx].classList.remove('is-active');
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add('is-active');
      enter(slides[idx]);
    }

    // The first upcoming slide warms only once the page has loaded, so its media
    // doesn't compete with the first slide for a phone's connection (theme 1.34.0).
    var warmNext = function () { warm(slides[(idx + 1) % slides.length]); };
    if (document.readyState === 'complete') warmNext();
    else window.addEventListener('load', warmNext, { once: true });
    enter(slides[idx]);
  });

  // Featured "see it in action": tap to toggle sound.
  document.querySelectorAll('.feature').forEach(function (f) {
    var fg = f.querySelector('.feat-fg');
    if (!fg || fg.tagName !== 'VIDEO') return;
    f.style.cursor = 'pointer';
    f.setAttribute('title', 'Tap for sound');
    f.addEventListener('click', function () {
      fg.muted = !fg.muted;
      if (!fg.muted) { var p = fg.play(); if (p && p.catch) p.catch(function () {}); }
    });
  });

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  // Honor *asterisk* accents in rotating words (matches snippets/accent.liquid): a
  // *…*-wrapped run becomes an orange <span class="em">…</span>; other text is escaped.
  function accentHTML(s) {
    var parts = String(s == null ? '' : s).split('*');
    var out = '';
    for (var k = 0; k < parts.length; k++) {
      var esc = parts[k].replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      out += (k % 2 === 1) ? '<span class="em">' + esc + '</span>' : esc;
    }
    return out;
  }
  // Hero animated headline — cycle the trailing phrase through data-hero-rotate.
  document.querySelectorAll('[data-hero-rotate]').forEach(function (el) {
    var words;
    try { words = JSON.parse(el.getAttribute('data-hero-rotate')); } catch (e) { return; }
    if (!Array.isArray(words) || words.length < 2) return;
    var secs = parseFloat(el.getAttribute('data-rotate-seconds')) || 3;
    if (secs < 1) secs = 1;
    var i = 0;
    if (!reduce) el.style.transition = 'opacity .22s ease';
    setInterval(function () {
      i = (i + 1) % words.length;
      if (reduce) { el.innerHTML = accentHTML(words[i]); return; }
      el.style.opacity = '0';
      setTimeout(function () { el.innerHTML = accentHTML(words[i]); el.style.opacity = '1'; }, 220);
    }, secs * 1000);
  });

  // EVERY KIND OF EVENT carousel — arrows scroll by a card; drag-to-scroll on desktop.
  document.querySelectorAll('.every-kind').forEach(function (sec) {
    var track = sec.querySelector('[data-ek-track]');
    if (!track) return;
    function step() { var c = track.querySelector('.ek-card'); return c ? c.getBoundingClientRect().width + 18 : 300; }
    var prev = sec.querySelector('[data-ek-prev]');
    var next = sec.querySelector('[data-ek-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    // Pointer drag (mouse) — touch already pans natively. Capture the pointer ONLY
    // once a real drag passes the threshold; a plain click never gets pointer
    // capture, so the card link follows normally. (Capturing on every pointerdown
    // swallowed the subsequent click, so clicking a card did nothing.)
    var down = false, dragging = false, startX = 0, startL = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; dragging = false; startX = e.clientX; startL = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragging && Math.abs(dx) > 4) {
        dragging = true;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (dragging) track.scrollLeft = startL - dx;
    });
    function end() { down = false; }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    // Suppress the click-through ONLY after an actual drag so it doesn't follow the
    // card link; a plain click is left alone so it navigates.
    track.addEventListener('click', function (e) {
      if (dragging) { e.preventDefault(); e.stopPropagation(); dragging = false; }
    }, true);
  });

  // Fade slider ([data-slides]) — WHAT ARRIVES image cards. Auto-advances, loops, and the
  // orange dash selector ([data-slides-dots]) jumps to a slide; the NN/NN counter tracks it.
  var pad2 = function (n) { return (n < 10 ? '0' : '') + n; };
  document.querySelectorAll('[data-slides]').forEach(function (box) {
    var imgs = Array.prototype.slice.call(box.querySelectorAll('img'));
    if (imgs.length < 2) return;
    var count = box.querySelector('[data-slides-count]');
    var dotsWrap = box.parentElement.querySelector('[data-slides-dots]');
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('button')) : [];
    var i = 0, timer = null, hovered = false;
    function show(n) {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach(function (im, k) { im.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (count) count.textContent = pad2(i + 1) + '/' + pad2(imgs.length);
    }
    // (Re)starts the loop from the current slide, so a picked slide gets a full interval.
    // Only a mouse resting on the photo holds it (below); a dot press never stops it.
    function play() { stop(); if (reduce || hovered) return; timer = setInterval(function () { show(i + 1); }, 3800); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); play(); }); });
    show(0);
    play();
    // Pause while a MOUSE rests on the photo so a reader isn't rushed. Touch is ignored:
    // a phone reports a finger arriving and leaving unreliably (a tap or a scroll can leave
    // it "entered"), which stopped the loop on phones (Peter, 2026-09-27).
    box.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hovered = true; stop(); } });
    box.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hovered = false; play(); } });
  });

  // Stat numbers ("40ft", "6+") — colour the trailing unit orange when the markup didn't.
  document.querySelectorAll('.stat .n').forEach(function (n) {
    if (n.querySelector('.u')) return; // already split in markup
    var m = /^(\s*[\d.,]+)(.+)$/.exec(n.textContent);
    if (!m) return;
    n.innerHTML = '';
    n.appendChild(document.createTextNode(m[1]));
    var u = document.createElement('span');
    u.className = 'u';
    u.textContent = m[2];
    n.appendChild(u);
  });

  // Header hamburger — toggle the mobile dropdown nav.
  document.querySelectorAll('[data-navtoggle]').forEach(function (btn) {
    var bar = btn.closest('.bar');
    if (!bar) return;
    btn.addEventListener('click', function () {
      var open = bar.classList.toggle('nav-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // Close the menu after a nav link is tapped.
    bar.querySelectorAll('.menu a').forEach(function (a) {
      a.addEventListener('click', function () { bar.classList.remove('nav-open'); btn.setAttribute('aria-expanded', 'false'); });
    });
  });
})();
